import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import coelabLogo from '../../assets/coelab-logo-black.png';

export interface CompleteStepProps {
  accentColor: string;
  isGuardian: boolean;
  onComplete: () => void;
}

const CompleteStep: FC<CompleteStepProps> = ({ accentColor, isGuardian, onComplete }) => {
  const subtitle = isGuardian
    ? "Your athlete's account is ready. You can now monitor their training, communicate with coaches, and stay connected."
    : 'Your account is ready — now you have the tools to perform at your best.';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: 360,
        mx: 'auto',
        py: 2,
      }}
    >
      {/* Checkmark badge — outer soft ring + inner filled circle */}
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: `${accentColor}20`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: accentColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckIcon sx={{ color: '#fff', fontSize: 28, fontWeight: 700 }} />
        </Box>
      </Box>

      {/* CoeLab wordmark */}
      <img src={coelabLogo} alt="CoeLab" style={{ height: 20, marginBottom: 16 }} />

      <Typography variant="h5" fontWeight={700} mb={1}>
        You&apos;re all set!
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={4} sx={{ lineHeight: 1.7 }}>
        {subtitle}
      </Typography>

      <Button
        variant="contained"
        fullWidth
        onClick={onComplete}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 700,
          fontSize: 15,
          backgroundColor: accentColor,
          boxShadow: 'none',
          letterSpacing: '0.02em',
          '&:hover': { backgroundColor: accentColor, filter: 'brightness(0.9)', boxShadow: 'none' },
        }}
      >
        Let&apos;s GO!
      </Button>
    </Box>
  );
};

export default CompleteStep;
